export default class CanalWhatsAppProviderEnum {
  static Zenvia = {
    id: 1,
    nome: 'Zenvia',
  }
}
